// Before generating an AVR preview PDF, verify that the two independently
// fetched report sections refer to the same approved findings. This is a
// browser-side safety net, NOT proof that a PDF is immutable or authorised
// for issue. The server-side approval-time snapshot remains authoritative.
const reference = value => String(value || '').trim().toUpperCase();
const status = value => String(value || '').trim().toLowerCase();

const indexRows = (rows, refKey, statusKey, section, errors) => {
  const found = new Map();
  for (const row of rows || []) {
    const ref = reference(row && row[refKey]);
    const state = status(row && row[statusKey]);
    if (!ref) {
      errors.push(section + ' contains a finding without a reference.');
      continue;
    }
    if (found.has(ref)) {
      errors.push(section + ' contains duplicate reference ' + ref + '.');
      continue;
    }
    if (!['open', 'closed'].includes(state)) {
      errors.push(section + ' contains ' + ref + ' with an unrecognised status.');
    }
    found.set(ref, state);
  }
  return found;
};

export const compareAvrFindingSections = (registerRows, detailRows) => {
  const errors = [];
  const register = indexRows(registerRows, 'finding_ref', 'status',
    'Finding Register', errors);
  const details = indexRows(detailRows, 'findingRef', 'currentStatus',
    'Finding Details', errors);

  for (const [ref, state] of register) {
    if (!details.has(ref)) errors.push(ref + ' is missing from Finding Details.');
    else if (details.get(ref) !== state)
      errors.push(ref + ' has a different Open/Closed status in Finding Details.');
  }
  for (const ref of details.keys()) {
    if (!register.has(ref)) errors.push(ref + ' is missing from Finding Register.');
  }

  return {
    ready: errors.length === 0,
    count: register.size,
    open: [...register.values()].filter(x => x === 'open').length,
    closed: [...register.values()].filter(x => x === 'closed').length,
    errors
  };
};
